import { authStore } from "@kaplan-labs/up-auth-api-client";

import type { TPartnerLite } from "@up/data";
import type { Options } from "ky";

let _partner: TPartnerLite | undefined = undefined;
const setPartner = function (partner: TPartnerLite) {
  _partner = partner;
};

const request = function <T>({
  url,
  data,
  options,
}: {
  url: string;
  data?: Record<string, unknown>;
  options?: Options;
}) {
  const $auth = authStore.get();
  const method = options?.method ?? "get";
  const decoratedOptions = {
    ...options,
    method,
  };

  if (data) {
    decoratedOptions.json = {
      ...data,
      partner: _partner,
    };
  }

  return $auth.client(url, decoratedOptions).json<T>();
};

export const network = {
  request,
  setPartner,
};
